import React from 'react'
import WarningBanner from 'components/Banners/WarningBanner'
import SuccessBanner from 'components/Banners/SuccessBanner'
import { Preview, Section, Col } from 'component-catalog/previews/PreviewKit'

export function BannersMock(): React.ReactElement {
  return (
    <Preview>
      <Section label="Warning banner">
        <Col>
          <WarningBanner text="LTV is being processed. You might not see the latest data." />
          <WarningBanner text="Your trial expires in 3 days. Upgrade to continue." />
        </Col>
      </Section>
      <Section label="Success banner">
        <Col>
          <SuccessBanner text="Your changes have been saved successfully." />
          <SuccessBanner text="Export complete — check your email for the download link." />
        </Col>
      </Section>
    </Preview>
  )
}
